import { getSettings } from './store'

/**
 * Vibration is the only guidance channel that works with the screen face-down
 * and the sound off — which is how a lot of these sessions actually happen.
 */

function buzz(pattern: number | number[]): void {
  if (!getSettings().haptics) return
  if (!('vibrate' in navigator)) return
  try {
    navigator.vibrate(pattern)
  } catch {
    /* some browsers throw on rapid calls; a missed buzz is not worth an error */
  }
}

export const haptic = {
  tap: () => buzz(12),
  soft: () => buzz(25),
  inhale: () => buzz([0, 40]),
  exhale: () => buzz([0, 90]),
  hold: () => buzz([0, 18, 60, 18]),
  complete: () => buzz([0, 60, 120, 60, 120, 140]),
  warn: () => buzz([0, 200, 100, 200]),
  off: () => {
    if ('vibrate' in navigator) navigator.vibrate(0)
  },
}
